export default "__VITE_ASSET__grhxDkVo__"